import React from "react";
import { motion } from "framer-motion";

import l1 from "../../Assets/images/L1.png";
import l2 from "../../Assets/images/L2.png";
import l3 from "../../Assets/images/L3.png";
import l4 from "../../Assets/images/L4.png";
import l5 from "../../Assets/images/L5.png";
import l6 from "../../Assets/images/L6.png";
import l7 from "../../Assets/images/L7.png";
import l8 from "../../Assets/images/l8.jpg"

const partners = [
  { id: 1, name: "Partner 1", logo: l1 },
  { id: 2, name: "Partner 2", logo: l2 },
  { id: 3, name: "Partner 3", logo: l3 },
  { id: 4, name: "Partner 4", logo: l4 },
  { id: 5, name: "Partner 5", logo: l5 },
  { id: 6, name: "Partner 6", logo: l6 },
  { id: 7, name: "Partner 7", logo: l7 },
  { id: 8, name: "Partner 8", logo: l8 },
];

const OurPartners = () => {
  return (
    <section className="pt-12 pb-16 lg:pt-20 bg-white overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        {/* HEADER */}
        <div className="text-center lg:pb-10 ">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="flex items-center justify-center gap-3 mb-2"
          >
            <div className="h-[2px] w-12 bg-orange-main" />
            <span className="text-xs font-bold uppercase tracking-[0.4em] text-orange-main">
              Our Partners
            </span>
            <div className="h-[2px] w-12 bg-orange-main" />
          </motion.div>
          
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.2 }}
            className="text-3xl lg:text-4xl font-bold text-gray-dark tracking-tighter"
          >
            Trusted by the <span className="text-teal-main font-black">Best</span>
          </motion.h2>
        </div>

        {/* SLIDER SECTION */}
        <div className="relative w-full overflow-hidden flex items-center h-28 sm:h-32 md:h-36 lg:h-40">
          
          {/* Left / Right Fade Gradients */}
          <div className="absolute left-0 top-0 bottom-0 w-12 sm:w-20 md:w-32 bg-gradient-to-r from-white to-transparent z-10 pointer-events-none" />
          <div className="absolute right-0 top-0 bottom-0 w-12 sm:w-20 md:w-32 bg-gradient-to-l from-white to-transparent z-10 pointer-events-none" />

          {/* Marquee Track */}
          <div className="flex w-fit animate-marquee hover:pause-marquee">
            {/* Duplicated list for seamless infinite loop */}
            {[...partners, ...partners].map((partner, index) => (
              <div 
                key={index}
                className="w-32 sm:w-40 md:w-52 lg:w-60 mx-4 sm:mx-6 md:mx-8 flex-shrink-0 flex items-center justify-center transition-transform duration-300 hover:scale-110 cursor-pointer"
              >
                <img 
                  src={partner.logo} 
                  alt={partner.name} 
                  className="max-h-16 sm:max-h-20 md:max-h-24 lg:max-h-28 w-auto object-contain" 
                />
              </div>
            ))}
          </div>
        </div>

      </div>

      {/* Internal Style for Keyframes */}
      <style dangerouslySetInnerHTML={{__html: `
        @keyframes marquee {
          0% { transform: translateX(0%); }
          100% { transform: translateX(-50%); }
        }
        .animate-marquee {
          animation: marquee 20s linear infinite;
        }
        .pause-marquee {
          animation-play-state: paused;
        }
      `}} />
    </section>
  );
};

export default OurPartners;
